import { obterEquipamentosAsync, obterEquipamentoAsync, obterEquipamentosPorPlanoAsync } from "../../services/equipamentoService";
import { obterImplementosAsync } from "../../services/implementoService";
import { obterAcessoriosAsync } from "../../services/acessorioService";
import { obterProprietariosAsync } from "../../services/proprietarioService";

const atualizarEquipamentos = async({ commit }) => {
    const equipamentos = await obterEquipamentosAsync();
    commit('atualizarEquipamentos', equipamentos);
}
const atualizarPlanoEquipamentos = async({ commit }, idPlano) => {
    const equipamentosPlano = await obterEquipamentosPorPlanoAsync(idPlano);
    commit('atualizarPlanoEquipamentos', equipamentosPlano);
}

const atualizarEquipamento = ({ commit }, equipamento) => {
    commit('atualizarEquipamento', equipamento);
}


const obterEquipamento = async({ commit }, idEquipamento) => {
    const equipamento = await obterEquipamentoAsync(idEquipamento);
    commit('atualizarEquipamento', equipamento);
    return equipamento;
}
const atualizarImplementos = async({ commit }) => {
    const implementos = await obterImplementosAsync();
    commit('atualizarImplementos', implementos);
}

const atualizarImplemento = ({ commit }, implemento) => {
    commit('atualizarImplemento', implemento);
}


const atualizarAcessorios = async({ commit }) => {
    const acessorios = await obterAcessoriosAsync();
    commit('atualizarAcessorios', acessorios);
}

const atualizarAcessorio = ({ commit }, acessorio) => {
    commit('atualizarAcessorio', acessorio);
}

const atualizarProprietarios = async({ commit }) => {
    const proprietarios = await obterProprietariosAsync();
    commit('atualizarProprietarios', proprietarios);
}

const atualizarProprietario = ({ commit }, proprietario) => {
    commit('atualizarProprietario', proprietario);
}

const updateEquipamento = ({ commit }, equipamento) => {
    commit('updateEquipamento', equipamento);
}

export default {
    atualizarEquipamentos,
    atualizarEquipamento,
    obterEquipamento,
    atualizarImplementos,
    atualizarImplemento,
    atualizarAcessorios,
    atualizarAcessorio,
	atualizarProprietarios,
	atualizarProprietario,
    atualizarPlanoEquipamentos,
    updateEquipamento
}